import { IUserSchema } from '../../../graphql/type/user';
import { IPhoneSubSchema } from '../../../graphql/type/subSchema/phone';
import { IUserWorkProfileSubSchema } from '../../../graphql/type/subSchema/userWorkProfile';

const user = {
  getTel: (
    tempUser: IUserSchema,
    workProfileCompanyId?: string
  ): IPhoneSubSchema | null => {
    let tel: IPhoneSubSchema | null = null;

    if (workProfileCompanyId) {
      const workProfiles =
        tempUser.profile && tempUser.profile.works
          ? tempUser.profile.works
          : [];

      const workProfile = workProfiles.find(
        (work) => work.id === workProfileCompanyId
      );

      if (workProfile) {
        const workProfileTels =
          workProfile.contact && workProfile.contact.tel
            ? workProfile.contact.tel
            : [];
        const workProfileTel = workProfileTels.find(
          (tempTel) => tempTel.primary && tempTel.status
        );
        tel = workProfileTel || workProfileTels[0];
      }
    } else {
      const userTels =
        tempUser.profile &&
        tempUser.profile.contact &&
        tempUser.profile.contact.tel
          ? tempUser.profile.contact.tel
          : [];

      if (userTels.length) {
        const userTel = userTels.find(
          (tempTel) => tempTel.primary && tempTel.status
        );
        tel = userTel || userTels[0];
      }
    }
    return tel;
  },
  getWorkProfile: (
    tempUser: IUserSchema,
    workProfileCompanyId?: string
  ): IUserWorkProfileSubSchema | undefined => {
    const workProfiles =
      tempUser.profile && tempUser.profile.works ? tempUser.profile.works : [];

    return workProfiles.find((work) => work.id === workProfileCompanyId);
  },
};
export default user;
